import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import styles from "./index.module.less";
import { connect } from "dva";
import ChatState from "@/types/chat/State";
import AISummaryDetail from "../AISummaryDetail";
import AIUnreadDetail from "../AIUnreadDetail";
import { Tooltip } from "antd";
import { FocusSDK } from "@/utils";
import { getAIChatWinSessionId } from "@/utils/chat/session";
import { buildAIChatMessageComm, convertEmployeeToString } from "@/utils/chat/message";
import { AI_CHAT_PREDICT, ChatMessageType } from "@/types/chat";

function mapDispatchToProps(dispatch: any) {
  return {
    dealStopQuestions(data: any) {
      dispatch({ type: "chat/dealStopQuestions", payload: data });
    },
    updateSelectSessionInfo(data: any) {
      dispatch({ type: "chat/updateSelectSessionInfo", payload: data });
    },
    setLastUnreadMessage(data: any) {
      dispatch({ type: "chat/setLastUnreadMessage", payload: data });
    }
  };
}

function mapStateToProps({ chat }: { user: any; chat: ChatState }) {
  return {
    selectedSession: chat.selectedSession,
    currentEmployee: chat.currentEmployee,
    sessionMessageMap: chat.sessionMessageMap
  };
}

// 智能未读消息摘要
function AIMessageSummaryBtn(props: any) {
  const {
    selectedSession,
    currentEmployee,
    sessionMessageMap,
    fixMsgs, // 定位到最后一条未读消息 未读消息数组
    unnreadCountPseudo, // 定位到最后一条未读消息
    accUnreadCount, // 定位到第一条未读消息
    tipText = "摘要总结"
  } = props;
  const [detailVisible, setDetailVisible] = useState<boolean>(false);

  const getUnReadMessages = useCallback(() => {
    let msgs;
    if (unnreadCountPseudo) {
      msgs = fixMsgs.filter((msg: any) => {
        return !msg.revoke;
      });
    } else {
      msgs = sessionMessageMap[selectedSession.sessionId] || [];
      if (accUnreadCount) {
        const count = Number(`-${accUnreadCount}`);
        msgs = msgs.slice(count).filter((msg: any) => {
          return !msg.revoke;
        });
      } else {
        msgs = msgs.filter((msg: any) => {
          return msg.mid > selectedSession?.lastReadMidFork && !msg.revoke;
        });
      }
    }
    const res: any[] = [];
    msgs.forEach((m: any) => {
      if (m?.replyMsgs && m?.replyMsgs[0] && !m?.replyMsgs[0]?.revoke) {
        res.push(
          ...[
            {
              username: m?.replyMsgs[0]?.sender?.name,
              userId: m?.replyMsgs[0]?.sender?.userId,
              content: m?.replyMsgs[0]?.content || ""
            },
            {
              username: m?.sender?.name,
              userId: m?.sender?.userId,
              content: m.type === ChatMessageType.TEXT ? m?.content || "" : "[非文本]"
            }
          ]
        );
      } else {
        res.push({
          username: m?.sender?.name,
          userId: m?.sender?.userId,
          content: m?.content || ""
        });
      }
    });
    return res;
  }, [
    unnreadCountPseudo,
    fixMsgs,
    sessionMessageMap,
    selectedSession?.sessionId,
    selectedSession?.lastReadMidFork,
    accUnreadCount
  ]);

  const sendToAIChat = useCallback(async () => {
    FocusSDK.launchAIChatSession(
      `aiRobot:dd.notice:focus.bot:${convertEmployeeToString(currentEmployee)}:chat`,
      () => {},
      true
    );
    const name = selectedSession?.info?.name;
    const sid = await getAIChatWinSessionId();
    const message = {
      type: ChatMessageType.TEXT,
      content: `帮我总结【${name}】的未读消息`,
      fixMessages: getUnReadMessages()
    };
    // 处理消息
    const msg = await buildAIChatMessageComm({
      sessionId: selectedSession.sessionId,
      currentEmployee,
      message,
      predictType: AI_CHAT_PREDICT.MESSAGE_SUMMARY,
      prompt: ""
    });
    FocusSDK.sendMainMessage("aichat.chatEvent", { sessionId: sid, data: msg });
  }, [currentEmployee, fixMsgs, getUnReadMessages, selectedSession]);

  return (
    <Tooltip title={detailVisible ? "" : tipText} placement="bottom">
      <div className={styles["ai-action-wrap"]} onClick={sendToAIChat}>
        <span className={styles["icon"]} />
        <span className={`${styles["text"]}`}>总结</span>
      </div>
    </Tooltip>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AIMessageSummaryBtn);
